<template>
  <div class="jps-curation-image" :class="imageClass">
    <UiImageSelectionViewer v-if="def.layout === 'viewer'" :image="imageSelection" />
    <UiImageSelection
      v-else
      :fullsize="true"
      :image="imageSelection"
      :style="heightStyle"
      :background="background"
      image-usage="thumbnail"
      @click.native="showModal()"
    />
    <CurationModal ref="curationModal" />
    <div class="jci-description">
      <div v-if="hasCaption" class="jci-caption">{{ ls(def.caption) }}</div>
      <div v-if="hasDescription" class="jci-description-text">
        {{ ls(def.description) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { CurationModal } from '#components';

const { ls } = useI18n()

interface Props {
  def: PartImage
}
const props = withDefaults(defineProps<Props>(), {})

const curationModal = ref<InstanceType<typeof CurationModal>>()
const showModal = async () => {
  try {
    const info: CurModalInfo = {
      image: imageSelection.value,
      title: imageSelection.value.title,
      description: imageSelection.value.description,
      link: imageSelection.value.sourceUrl,
      source: imageSelection.value.source,
      rights: imageSelection.value.contentsRights,
      rightsType: imageSelection.value.contentsRightsType,
      sourceUrl: imageSelection.value.sourceUrl,
      internalLink: imageSelection.value['internalLink'],
      data: imageSelection.value['data'],
      type: imageSelection.value['data'] ? 'item' : null,
    }
    await curationModal.value.openAwait({
      info: info
    },
    {
      animation: 'slideY',
      history: info.data ? info.data.id : '0'
    })
  } catch (cancel) {}
}

const {
  imageClass,
  heightStyle,
  imageSelection,
  background,
  hasCaption,
  hasDescription
} = useCurationImage(props.def)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/components/_curation-image';
</style>